import axios from 'axios';
import { useEffect, useState } from 'react';

const backendUrl = process.env.REACT_APP_BACKEND_URL;

export interface CookiePreferencesState {
  essential: 'true';
  analytics: 'true' | 'false';
  adsTracking: 'true' | 'false';
  thirdParty: 'true' | 'false';
  consent: 'true' | 'false';
}

interface CookiePreferencesResponse {
  preferences: CookiePreferencesState;
}

const defaultPreferences: CookiePreferencesState = {
  essential: 'true',
  analytics: 'false',
  adsTracking: 'false',
  thirdParty: 'false',
  consent: 'false',
};

const CookiesPreferences = (): JSX.Element => {
  const [preferences, setPreferences] = useState<CookiePreferencesState>(defaultPreferences);

  useEffect(() => {
    axios
      .get<CookiePreferencesResponse>(`${backendUrl}/cookies/get-cookie-user-preferences/`, { withCredentials: true })
      .then((response) => {
        setPreferences(response.data.preferences);
      })
      .catch((error) => console.error('Error fetching preferences:', error));
  }, []);

  const handleApprove = (): void => {
    axios
      .post(
        `${backendUrl}/cookies/set-cookie-user-preferences/`,
        JSON.stringify({ preferences, consent: 'true' }),
        {
          withCredentials: true,
          headers: { 'Content-Type': 'application/json' },
        },
      )
      .then(() => {
        window.location.reload();
      })
      .catch((error) => console.error('Error updating preferences:', error));
  };

  return (
    <div
      style={{
        padding: '20px',
        border: '1px solid var(--border-color)',
        borderRadius: '8px',
        maxWidth: '400px',
        margin: 'auto',
        backgroundColor: 'var(--surface-elevated)',
        color: 'var(--text-color)',
      }}
    >
      <h2>Manage Cookie Preferences</h2>
      <p>Choose how we handle cookies for your experience:</p>

      <p>
        <strong>Essential Cookies:</strong> Always Enabled ✅ (Required for website functionality)
      </p>

      <label>
        <input
          type="checkbox"
          checked={preferences.analytics === 'true'}
          onChange={() =>
            setPreferences({
              ...preferences,
              analytics: preferences.analytics === 'true' ? 'false' : 'true',
            })
          }
        />
        Allow Analytics & Performance Cookies
      </label>

      <label>
        <input
          type="checkbox"
          checked={preferences.adsTracking === 'true'}
          onChange={() =>
            setPreferences({
              ...preferences,
              adsTracking: preferences.adsTracking === 'true' ? 'false' : 'true',
            })
          }
        />
        Allow Advertising & Tracking Cookies
      </label>

      <label>
        <input
          type="checkbox"
          checked={preferences.thirdParty === 'true'}
          onChange={() =>
            setPreferences({
              ...preferences,
              thirdParty: preferences.thirdParty === 'true' ? 'false' : 'true',
            })
          }
        />
        Allow Third-Party Cookies
      </label>

      <button
        onClick={handleApprove}
        style={{
          marginTop: '10px',
          padding: '8px 12px',
          cursor: 'pointer',
          backgroundColor: 'var(--accent-color)',
          color: 'var(--surface-elevated)',
          border: 'none',
          borderRadius: '5px',
        }}
      >
        Approve Selected
      </button>
    </div>
  );
};

export default CookiesPreferences;
